<template>
  <span class="status-string" :class="[`text-${variant}`, `size-${size}`]">
    <span class="status-string-badge" />
    <b v-if="text" class="status-string-text">{{ text }}</b>
  </span>
</template>

<script setup lang="ts">
import { StatusVariantColor } from '@/core/types/components/status';

defineProps<{
  text?: string;
  variant?: StatusVariantColor;
  size?: 'M' | 'S';
}>();
</script>

<style scoped lang="scss">
.status-string {
  display: flex;
  align-items: center;

  &.size-M {
    .status-string-text {
      font-size: 12px;
    }
  }
  &.size-S {
    .status-string-text {
      font-size: 10px;
    }
  }

  &-badge {
    display: block;

    min-width: 8px;
    max-width: 8px;
    height: 8px;

    background-color: currentColor;
    border-radius: 50%;
  }

  &-text {
    margin-left: 0.5em;
  }

  &-text {
    font-size: 14px;
    @include ellipsis();
  }
}
</style>
